import firebase from 'firebase/app'
import "firebase/auth"
import "firebase/firestore"

import firebaseConfig from './config'

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

const firestore = firebase.firestore()
const auth = firebase.auth()

// Disable deprecated features
firestore.settings({
  timestampsInSnapshots: true
});

export { auth, firestore }



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/firebase/index.js